import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { Concept, useContent } from './contentContext';
import { topicIcon } from './topicIcons';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    width: 300,
    display: 'flex',
    flexDirection: 'column',
  },
  actionArea: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  iconHeader: {
    height: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #3f51b5 0%, #7986cb 100%)',
    color: '#fff',
  },
  iconHeaderIcon: {
    fontSize: 48,
  },
  tags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 8,
  },
});

const ConceptCard = ({ concept }: { concept: Concept }) => {
  const classes = useStyles();
  const { topics } = useContent();
  const to = `/learn/${concept.topic}/${concept.id}`;
  const topic = topics.find((t) => t.id === concept.topic);
  const Icon = topicIcon(topic ? topic.icon : '');

  return (
    <Card className={classes.root}>
      <CardActionArea component={Link} to={to} className={classes.actionArea}>
        {concept.image ? (
          <CardMedia
            component="img"
            alt={concept.title}
            height="140"
            image={`${process.env.PUBLIC_URL || ''}${concept.image}`}
            title={concept.title}
          />
        ) : (
          <div className={classes.iconHeader}>
            <Icon className={classes.iconHeaderIcon} fontSize="inherit" />
          </div>
        )}
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {concept.title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {concept.description}
          </Typography>
          {concept.tags.length > 0 && (
            <div className={classes.tags}>
              {concept.tags.map((tag) => (
                <Chip key={tag} label={tag} size="small" />
              ))}
            </div>
          )}
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary" component={Link} to={to}>
          Learn More
        </Button>
      </CardActions>
    </Card>
  );
};

export default ConceptCard;
